var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "settings-container" }, [
    _c(
      "div",
      { staticClass: "settings-mobile-header" },
      [
        _c("animated-hamburger", {
          attrs: { "is-showing": _vm.showMobileMenu },
          on: { clicked: _vm.toggleMobileMenu },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "settings-mobile-title" }, [
          _vm._v(_vm._s(_vm.currentSettingsTitle)),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "settings-sidebar",
        class: { "settings-sidebar-mobile-open": _vm.showMobileMenu },
      },
      _vm._l(_vm.navMenu, function (category) {
        return _c(
          "b-nav",
          {
            key: category.title,
            staticClass: "settings-sidebar-category",
            attrs: { vertical: "" },
          },
          [
            _c("div", { staticClass: "settings-nav-cat-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t(category.title).toUpperCase()) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm._l(
              category.links.filter((l) => l.visible),
              function (link) {
                return _c(
                  "localized-link",
                  {
                    key: link.title,
                    class: {
                      "settings-nav-item ": true,
                      "disabled-settings-nav-item": !link.enabled,
                    },
                    attrs: {
                      to: link.uri,
                      "active-class": "settingsNavItemActive",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.closeMobileMenuIfOpen.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("b-nav-item", { staticClass: "settings-menu-item" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(link.title)) +
                          "\n        "
                      ),
                    ]),
                  ],
                  1
                )
              }
            ),
          ],
          2
        )
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "settings-window-container",
        class: {
          "settings-window-mobile": _vm.isMobileView,
          "banner-visible": _vm.showSetupBanner,
        },
      },
      [
        _vm.showSetupBanner
          ? _c("div", { staticClass: "setup-notification-header" }, [
              _c(
                "div",
                { staticClass: "setup-notification-content" },
                [
                  _c("i", { staticClass: "fi-info-circle mr-2" }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("setup.navbar_header")) +
                      "\n        "
                  ),
                  _c(
                    "router-link",
                    { staticClass: "setup-link", attrs: { to: "/en/setup" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("setup.navbar_header_link")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("router-view"),
      ],
      1
    ),
    _vm._v(" "),
    _vm.showMobileMenu && _vm.isMobileView
      ? _c("div", {
          staticClass: "settings-mobile-backdrop",
          on: {
            click: function ($event) {
              _vm.showMobileMenu = false
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }